import IListFilter from "@/models/IListFilter";
import {isEmpty} from "@/helpers/functions_asi";

export default class PlanningEntryListFilter implements IListFilter {

	public fulltext: string | null = null;

	public orderCompanyName: string | null = null;
	public orderName: string | null = null;
	public orderId: string | null = null;
	public dateFrom: string | null = null;
	public dateTo: string | null = null;
	public userName: string | null = null;
	public userId: string | null = null;
	public notes: string | null = null;

	public hasReports: boolean | null = null;

	clear(): void {
		this.fulltext = null;
		this.orderCompanyName = null;
		this.orderName = null;
		this.orderId = null;
		this.dateFrom = null;
		this.dateTo = null;
		this.userName = null;
		this.userId = null;
		this.notes = null;
		this.hasReports = null;
	}

	hasFilter(): boolean {
		return !isEmpty(this.fulltext)
			|| !isEmpty(this.orderCompanyName)
			|| !isEmpty(this.orderName)
			|| !isEmpty(this.dateFrom) || !isEmpty(this.dateTo)
			|| !isEmpty(this.userName)
			|| !isEmpty(this.notes)
			|| this.hasReports !== null;
	}

}
